define('app/views/success_view',['app/setup', 'app/views/async_loading_coupons', 'app/views/success_bank_card_view'], function(takhfifan) {

  takhfifan.SuccessView = Backbone.View.extend({

    initialize: function() {
      this.render();
      var $this = this.$el;
      if(_.isFunction(window.ga)){
        ga('send', 'event', {
          eventCategory: 'customer',
          eventAction: 'purchase',
          eventLabel: $this.data('newCustomer') ? 'new customer': 'returning customer',
          eventValue: $this.data('total')
        });
      }

      var guestEmail = this.$el.data('customerEmail');
      if(guestEmail){
        takhfifan.eventHub.on('customer:sessionAquired', function(){
          takhfifan.eventHub.trigger('guest_customer_info:email', {email:guestEmail});
        });
      }

      $('.tkh-loading-coupons').each(function(){
        var $this = $(this);
        new takhfifan.AsyncLoadingCoupons({
          el: $this
        });
      });

      $('.tkh-bank-card').each(function(){
        var $this = $(this);
        new takhfifan.SuccessBankCardView({
          el: $this
        });
      });

      $('#save_mobile_num').on('click',function () {
        var no = $('#mobilenumget').val();
        $("#save_mobile_num").prop("disabled",true);
        $('.mobile-error-box').css('display','none');
        var saveData =
            $.ajax({
              type: 'POST',
              url: "/ajax/forms/saveUserMobile",
              data: {mobile:no},
              dataType: "text",
              success: function(resultData) {
                resultData= jQuery.parseJSON(resultData);
                $('.mobile-error-box').css('display','none');
                $("#save_mobile_num").prop("disabled",false);

                if (resultData.success == false){
                  if (resultData.message == 'Invalid Number'){
                    $('.mobile-error-box').text('شماره وارد شده صحیح نمی باشد');
                    $('.mobile-error-box').css('display','block');
                  }else{
                    console.log(resultData.error);
                    $('.mobile-error-box').text('مشکلی زخ داده است. دوباره تلاش کنید');
                    $('.mobile-error-box').css('display','block');
                  }

                } else if (resultData.success == true){
                  $('.get-mobile-box-origin').css('display','none');
                  $('.mobile-success-box').css('display','block');
                }
              }
            });

        saveData.error(function() {
          $('.mobile-error-box').css('display','block');
          $("#save_mobile_num").prop("disabled",false);
        });
      });

      gtag('event', 'conversion', {
        'send_to': 'AW-1017887658/t3PGCLfmrYcBEKr3ruUD',
        'value': $this.data('total'),
        'currency': 'USD',
        'transaction_id': '',
    });

    },

    render: function() {
      this.$el.show();
    }

  });

  $('.tkh-success').each(function(){
    var $this = $(this);
    new takhfifan.SuccessView({
      el: $this
    });
  });

});

